// extracted by mini-css-extract-plugin
module.exports = {"bodywrapper":"template_bodywrapper__3Jbea","logo":"template_logo__2bVjO"};